import { useStoreSelector } from 'store/hooks/storeHooks';

export const useFeatureFlag = (flags: string | string[]): any => {
  const { featureFlags } = useStoreSelector((state) => state.featureFlags);

  // TODO: REMOVE MEEE
  // if (flags === 'tempWebEnableSearchMicrofrontend') {
  //   return true;
  // }

  if (Array.isArray(flags)) {
    return flags.map((flag) => !!featureFlags?.[flag]);
  }

  return !!featureFlags?.[flags];
};
